import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { StoreId } from "../../../../types";
import image from "../../assets/wifi/wall/u6-extender.png";
import type { Product } from "../../types";
import { wifiWall } from "../product-list-groups/wifiWall";
import {
  connectedDevices,
  customization,
  dimensions,
  integratedSwitch,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const u6Extender: Product = {
  id: "u6Extender",
  productTitle: "U6 Extender",
  techspecsPath: [SiteId.TechSpecs, "/unifi/wifi/u6-extender"],
  storePathParts: {
    productSlug: "u6-extender",
    category: UniFiChildCategorySlug.WiFiWall,
  },
  sku: "U6-Extender-US",
  description: "u6Extender.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiWall,
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u6Extender.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: (storeId: StoreId) => {
          switch (storeId) {
            case StoreId.Us:
              return "u6Extender.dimensions.us";
            default:
              return "u6Extender.dimensions.eu";
          }
        },
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "115 m² (1,250 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "300+" },
    },
    {
      propertyId: integratedSwitch.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "powerMethodPoe",
      value: {
        type: "translation",
        value: "u6Extender.wifiPowerMethod",
      },
    },
    {
      propertyId: uplink.id,
      value: {
        type: "translation",
        value: "u6Extender.uplink",
      },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "u6Extender.mounting",
      },
    },
    {
      propertyId: customization.id,
      value: {
        type: "translation",
        value: "u6Extender.customization",
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
};
